import constants from "../../Utils/constants";
import useTranslator from "../../hooks/useTranslator";
import { Badge } from "../design";

export const isClientIdentificationPending = (tenant, ruleEnabled) =>
  ruleEnabled === true &&
  Boolean(tenant) &&
  tenant?.consents?.client_identification_consent?.status !==
    constants.ACCEPTED;

const ClientIdentificationStatus = () => {
  const { _t } = useTranslator();

  return <Badge tone="warning">{_t("amlSigningPending")}</Badge>;
};

export default ClientIdentificationStatus;
